/**
 * @function getExternalReferences
 * @description Récupére la liste des référence des commandes importer par l'utilisateur
 * @param {object[]} commands - commands
 * @returns {string[]} tableau contant toute les référence de commande
 */

const getExternalReferences = commands => ({
  externalReferences: commands.map(command => command.externalReference)
});

export default getExternalReferences;
